<rt-admins-avatars
  rtTooltip
  [admins]="_users"
  [limit]="2"
  [stacked]="true"
  [editable]="false"
  [moreButtonAsCounter]="true"
  [counterAvatarTemplate]="followersCounterTpl"
  [tooltipsEnabled]="false"
  [hasStopPropagation]="false"
  [rtTooltipTemplate]="followersTooltipTpl"
  rtTooltipPosition="below"
  avatarSize="small-x"
  margin-left-small-xx
  margin-right-small-xxx
/>

<ng-template #followersTooltipTpl>
  <p class="heading" margin-bottom-small-xx>
    <strong>
      {{
        'app.follow_dropdown.followers_count_tooltip_heading' | translate: { count: _users.length }
      }}
    </strong>
  </p>
  @for (visibleUser of visibleUsers; track trackById($index, visibleUser)) {
    <ng-container
      [ngTemplateOutlet]="followerTpl"
      [ngTemplateOutletContext]="{
        user: visibleUser,
        leftSlotTpl: avatarTpl,
        leftSlotTplCtx: { user: visibleUser },
      }"
    ></ng-container>
  }
  @if (otherFollowersCount > 0) {
    <ng-container
      [ngTemplateOutlet]="followerTpl"
      [ngTemplateOutletContext]="{
        leftSlotTpl: followersCounterTpl,
        leftSlotTplCtx: { count: otherFollowersCount, hideOutline: true },
      }"
    ></ng-container>
  }
</ng-template>

<ng-template
  #followerTpl
  let-user="user"
  let-leftSlotTpl="leftSlotTpl"
  let-leftSlotTplCtx="leftSlotTplCtx"
>
  <div layout layout-align-items-center margin-bottom-small-xx>
    <ng-container
      [ngTemplateOutlet]="leftSlotTpl"
      [ngTemplateOutletContext]="leftSlotTplCtx"
    ></ng-container>
    <span class="follower-full-name" margin-left-small>
      @if (user) {
        {{ user.firstName }}&nbsp;{{ user.lastName }}
      } @else {
        {{ 'app.common.other' | translate }}
      }
    </span>
  </div>
</ng-template>

<ng-template #followersCounterTpl let-count="count" let-hideOutline="hideOutline">
  <rt-total-followers-counter [count]="count ?? _users.length" [hasOutline]="!hideOutline" />
</ng-template>

<ng-template #avatarTpl let-user="user">
  <rt-avatar
    [type]="user.hasAvatar ? 'image' : 'initials'"
    [initials]="user.initials"
    [imageSrc]="user.photoThumbUrl"
    context="admin"
    size="small-x"
  />
</ng-template>
